import type { OrderEventListFiltersShared } from '@klear/order-event/order-event-list-filters-shared.wire'
import type { OperationalListItem } from '@klear/operational/operational-list.wire'
import { trpc } from '@klear/ui/lib/trpc'
import {
  isSharedOrderEventListQueryEnabled,
  type SharedOrderEventListQueryOptions
} from '@klear/ui/hooks/order-event-list-query-options'

const EMPTY_OPERATIONALS: OperationalListItem[] = []

export function useOperationals(filters?: OrderEventListFiltersShared, options?: SharedOrderEventListQueryOptions) {
  const isEnabled = isSharedOrderEventListQueryEnabled(filters, options)

  const { data, error, isLoading, refetch } = trpc.operational.list.useQuery(filters ?? {}, { enabled: isEnabled })

  const operationals = data?.operationals ?? EMPTY_OPERATIONALS

  return { operationals, total: data?.total ?? 0, error, isLoading, refetch }
}
